<template>
    <div :class="['media-uploader', 'upload-image', {
        'pointer-events-none': disableMouseEventsData,
        'media-uploader--disabled': isDisabled,
    }]">
        <div :class="{'panelar py-4': isLegacy }">
            <!-- TODO: Update with <uploader-privacy-flag -->
            <template v-if="privacyPolicyEnabled">
                <div class="form-row" v-if="savedImagesLoadingComplete && enabledPhotoFlag">
                        <div class="form-group col-md-1 mb-0">
                            <label
                                for="boxphoto"
                                class="switch switch-left-right mb-0"
                                :data-content="i18n.acceptToUpload"
                                data-toggle="popover"
                                data-placement="bottom"
                                data-trigger="focus"
                                ref="uploadFlagLabel"
                            >
                                <input
                                    name="photo_flag"
                                    v-model="uploadFlag"
                                    id="boxphoto"
                                    type="checkbox"
                                    value="on"
                                    class="switch-input form-control"
                                    ref="uploadFlag"
                                />
                                    <span :data-on="i18n.yes" :data-off="i18n.no" class="switch-label"></span>
                                    <span class="switch-handle"></span>
                            </label>
                        </div>
                    </div>
                    <div class="col-md-10 txt_privacy pt-2">
                        <p v-if="countryCode === 'BR'">
                            <strong>
                                Ao submeter o an&uacute;ncio, o usu&aacute;rio declara ser maior de 18 anos e concorda que ser&aacute; o
                                &uacute;nico respons&aacute;vel pela veracidade das informa&ccedil;&otilde;es e imagens enviadas &agrave; Plataforma
                                SKOKKA.
                            </strong>
                            <br />
                                O envio de imagens e dados n&atilde;o autorizados por seus titulares &eacute; absolutamente vedado e causar&aacute; a
                                remo&ccedil;&atilde;o do an&uacute;ncio. O usu&aacute;rio est&aacute; sujeito &agrave;s penalidades cab&iacute;veis na
                                esfera c&iacute;vel e criminal por eventuais danos ou preju&iacute;zos causados pelas informa&ccedil;&otilde;es
                                inseridas na plataforma, inclusive perante terceiros.
                        </p>
                        <!-- TODO: Check translations -->
                        <p v-else v-html="i18n.privacyText"></p>
                    </div>
            </template>

            <ui-alert
                v-if="editImagesOnlyMessage"
                :title="i18n.activePromotion"
                :description="i18n.canOnlyEditYourPhotos"
            />

            <div ref="imageBox">
                <ui-alert
                    v-if="savedImagesLoadingComplete && imagesArray.length > 1 && !forceDisableSorting"
                    class="onlydk"
                    dismissable
                    :description="i18n.alertSavedImagesLoadingComplete"
                />

                <!-- TODO: Add transition component here for a better UI -->
                <!-- https://v2.vuejs.org/v2/guide/transitions -->
                <uploader-progress
                    v-if="savedImagesLoadingProgress < 100"
                    :progress="savedImagesLoadingProgress"
                    class="h-100"
                />

                <draggable
                    v-show="savedImagesLoadingProgress === 100"
                    v-model="imagesArray"
                    class="row"
                    draggable=".draggable-image-editor"
                    :force-fallback="draggableForceFallback"
                    ghost-class="sortable-ghost"
                    :disabled="disableSorting"
                    :flag-disable="imageFlagDisable"
                    filter=".no-drag"
                >
                    <image-editor
                        v-for="image, index in imagesArray"
                        :key="image.uuid"
                        :image-src="image.src"
                        :image-src-version="{ name: imageSrcVersionName, value: imageSrcVersionValue }"
                        :image-browser-src="browserImages[image.uuid] ? browserImages[image.uuid].browserSrc : null"
                        :is-cover="image.isCover"
                        :is-allowed="image.isAllowed"
                        :disable-sorting="disableSorting"
                        :initial-rotation="image.rotate"
                        :initial-crop="image.crop"
                        :initial-allowed="image.is_allowed"
                        class="col-xs-6 col-sm-6 col-md-3 mb-3 h-100 draggable-image-editor"
                        :style="disableSorting ? 'box-shadow:none;' : ''"
                        :flag-disable="imageFlagDisable"
                        :cropper-modal-image-max-width="imageMaxSizeWidth"
                        :cropper-modal-image-max-height="imageMaxSizeHeight"
                        :too-small-alert-message="i18n.imageTooSmall"
                        :image-not-allowed-message="i18n.imageNotAllowed"
                        :image-not-allowed-preview-message="i18n.imageNotAllowedPreview"
                        :one-image-free-ad-alert="oneImageFreeAdAlert"
                        :post-promote-url="postPromoteUrl ? postPromoteEncoded : null"
                        :is-update="isUpdate"
                        :disable-crop="disableCrop"
                        :disable-rotate="disableRotate"
                        :disable-preview-header="disablePreviewHeader"
                        @image-load-completed="onImageLoadCompleted(image.uuid, ...arguments)"
                        @remove-image="deleteImage(index)"
                        @set-cover="setCover(index)"
                        @updated-edit-data="updateImageEditData(index, ...arguments)"
                        @cropper-modal-shown="cropperModalShown(index)"
                        @cropper-modal-hidden="cropperModalHidden(index)"
                        @client-size-data="onClientSizeData(image.uuid, ...arguments)"
                    />

                    <div
                        v-if="imagesArray.length < initNumberOfAllowedImages"
                        :class="imagesArray.length === 0 ? 'col-12' : 'col-md-3 col-xs-6 col-sm-6'"
                        :style="uploadBoxStyle"
                    >
                        <uploader-progress
                            v-if="isUploading"
                            :progress="uploadProgress"
                            class="h-100"
                        />
                        <!-- TODO: This could be a component itself to improve readability -->
                        <div
                            v-else
                            class="media-uploader__drop-zone border-with-dashed"
                            ref="uploadDropZone"
                            @dragover.prevent
                            @drop="handleFileDrop"
                        >
                            <label class="media-uploader__label">
                                <div class="media-uploader__text media-uploader__text--uppercase media-uploader__text--with-counter" v-html="uploadableImagesText"></div>
                                <i class="media-uploader__camera-icon fa fa-camera fa-2x" aria-hidden="true"></i>
                                <div class="media-uploader__text media-uploader__text--capitalize">
                                    <span class="txtnomobile">{{ i18n.dragAndDropInstructionsNoMobile }}</span>
                                    {{ i18n.dragAndDropInstructions }}
                                </div>
                                <input
                                    id="upload"
                                    :accept="acceptedType"
                                    class="upload"
                                    @change="loadImageInput"
                                    type="file"
                                    multiple
                                />
                            </label>
                        </div>
                    </div>
                </draggable>

                <div v-if="isLegacy && savedImagesLoadingComplete" class="panel-heading text-center">
                    <p class="small mb-3">{{ i18n.loadingCompleteMessage }}</p>
                    <ui-alert
                        v-if="oneImageFreeAdAlert"
                        :description="i18n.onlyOnePictureForFreeAds"
                    />
                </div>
            </div>

            <!-- TODO: Replace with modal-component -->
            <div class="modal" ref="lightboxInvalidImage" tabindex="-1" data-backdrop="static">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title text-uppercase">
                                {{ i18n.modalInvalidImageTitle }}:
                            </h5>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex flex-column bd-highlight mb-3">
                                <div class="p-2 bd-highlight">
                                    <span v-if="lightboxInvalidImageMessageContent">
                                        {{ lightboxInvalidImageMessageContent }}
                                    </span>
                                    <span v-else-if="lightboxInvalidImageErrorCodes.size > 0">
                                        <div>{{ i18n.modalImagesNotSaved }}</div>
                                        <div v-show="lightboxInvalidImageErrorCodes.has(ERROR_CODE_INVALID_FORMAT)" v-html="modalImageNotSavedInstructionsText"></div>
                                        <div v-show="lightboxInvalidImageErrorCodes.has(ERROR_CODE_INVALID_FORMAT)" v-html="i18n.modalImageNotSavedInstructions1"></div>
                                        <div v-show="lightboxInvalidImageErrorCodes.has(ERROR_CODE_INVALID_CONTENT)">{{ i18n.modalImageNotSavedInstructions2 }}</div>
                                        <div v-show="lightboxInvalidImageErrorCodes.has(ERROR_CODE_MULTIPLE_FACES)">{{ i18n.modalImageNotSavedInstructions3 }}</div>

                                    </span>
                                    <span v-else>
                                        <div>{{ i18n.modalImagesNotSaved }}</div>
                                        <div v-html="modalImageNotSavedInstructionsText"></div>
                                        <div v-html="i18n.modalImageNotSavedInstructions1"></div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-center">
                            <button
                                type="button"
                                @click="closeErrorLightbox"
                                class="btn btn-primary waves-effect waves-light">
                                {{ i18n.close }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.pointer-events-none {
  pointer-events: none;
}
.media-uploader .img-cover-checkbox+.card {
    display: inline-block;
    border-radius: inherit;
    padding: 10px;
}
.media-uploader .img-cover-checkbox+.card:hover {
    cursor: pointer;
}
.media-uploader .img-cover-checkbox:checked+.card {
    background-color: var(--color-secondary);
    border-radius: 0px;
}
.media-uploader .img-preview-label {
    display: inline-block;
}
.media-uploader .img-preview-label::after {
    color: #666666;
    font-size: 10px;
}
.media-uploader .img-cover-checkbox:checked+.card .img-preview-label::after {
    color: #ffffff;
}
.media-uploader .img-preview-label::before {
    content: '\f006';
    color: #666666;
    font-family: 'FontAwesome';
    margin-right: 5px;
}
.media-uploader .img-cover-checkbox:checked+.card .img-preview-label::before {
    content: '\f005';
    color: #ffffff;
    font-family: 'FontAwesome';
}
.media-uploader .cropperdiv {
    margin: 0px auto;
}
.media-uploader .cropperdiv img {
    display: block;
    /* This rule is very important, please don't ignore this */
    max-width: 100%;
}
.media-uploader .cropperdiv > img {
    /* Hide image, but preserve space for cropper */
    opacity: 0.0;
    filter: alpha(opacity=0.0); /* For IE8 and earlier */
}
.media-uploader .cropperZoomSliderContainer {
    width: 100%; /* Width of the outside container */
}
/* The slider itself */
.media-uploader .cropperZoomSlider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 15px;
    background: #E0E0E0;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
    border-radius: 10px;
    box-shadow: inset 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
}
/* Mouse-over effects */
.media-uploader .cropperZoomSlider:hover {
    opacity: 1; /* Fully shown on mouse-over */
}
/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.media-uploader .cropperZoomSlider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    background: var(--color-primary);
    cursor: pointer;
    border-radius: 20px;
}
.media-uploader .cropperZoomSlider::-webkit-slider-thumb:active{
    -webkit-appearance: none;
    appearance: none;
    width: 30px;
    height: 30px;
    background: var(--color-primary);
    border: 4px solid;
    border-color: var(--color-secondary);
}
.media-uploader .cropperZoomSlider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    background: var(--color-primary);
    cursor: pointer;
    border-radius: 20px;
}
.media-uploader .upload-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
}

.media-uploader--disabled {
  z-index: 1000;
  background-color: rgb(255, 255, 255);
}
.media-uploader--disabled img.preview {
    cursor: not-allowed;
}
.media-uploader--disabled label {
    cursor: not-allowed;
    pointer-events: none;
}
.media-uploader--disabled .card-input-element:checked+.card {
    cursor: not-allowed;
    pointer-events: none;
}
.media-uploader--disabled .card-input-element:checked+.card {
    cursor: not-allowed;
    pointer-events: none;
}
.media-uploader--disabled .insertphoto {
    cursor: not-allowed;
    pointer-events: none;
}
.media-uploader--disabled .insertphoto a {
    cursor: not-allowed;
    pointer-events: none;
}
.media-uploader--disabled .fa {
    cursor: not-allowed;
    pointer-events: none;
}
.media-uploader--disabled .uploadphoto {
    cursor: not-allowed;
    pointer-events: none;
}
.media-uploader--disabled .card-input-element + .card::before {
    cursor: not-allowed;
    pointer-events: none;
}
.media-uploader--disabled .media-uploader .card-input-element + .card::after {
    cursor: not-allowed;
    pointer-events: none;
}

.media-uploader__drop-zone {
    background-color: transparent;
    text-align: center;
    width: 100%;
    height: 100%;
}
.media-uploader__label {
    margin-bottom: 0;
    padding: 15px;
    width: 100%;
    height: 100%;
    display: flex;
    min-height: var(--media-uploader-min-height);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    align-self: stretch;
    cursor: pointer;
}
.media-uploader .progress {
    min-height: var(--media-uploader-min-height);
}
.media-uploader__text {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    color: #666;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 19.44px; /* 162% */
}
.media-uploader__text--uppercase {
    text-transform: uppercase;
}
.media-uploader__text--with-counter span {
    color: var(--color-primary);
    font-weight: bold;
}
.media-uploader__text--capitalize {
    text-transform: capitalize;
}
.media-uploader__camera-icon {
    color: var(--color-primary);
}
.media-uploader__counter {
    color: var(--color-primary);
}
@media(min-width: 768px) {
    .media-uploader__label {
        padding: 30px 15px;
    }
}
</style>

<script>
// import Translations from "./insert-me-to-translate.vue";

import fill from "lodash/fill";
import sum from 'lodash/sum';
import has from 'lodash/has';
import map from 'lodash/map';
import get from 'lodash/get';
import maxBy from 'lodash/maxBy';
import values from 'lodash/values';
import isUndefined from 'lodash/isUndefined';

const loadPica = () => import(/* webpackChunkName: "chunk-pica", webpackPrefetch: true */ 'pica');

const loadBowser = () => import(/* webpackChunkName: "chunk-bowser" */ 'bowser');

// Returns a promise that resolves with an image element when the image loads, or rejects on error.
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener("load", () => resolve(img));
    img.addEventListener("error", err => reject(err));
    img.src = src;
  });
};

// Reads a file as an ArrayBuffer using FileReader and returns a promise that resolves with the data on success, or rejects on error.
function pReadFileAsArrayBuffer(file){
  return new Promise((resolve, reject) => {
    let fr = new FileReader();
    fr.addEventListener("load", () => resolve(fr.result));
    fr.addEventListener("error", err => reject(err))
    fr.readAsArrayBuffer(file); // Initiates reading the file as an ArrayBuffer
  });
};

export default {
    components: {
        ImageEditor: () => import(/* webpackChunkName: "chunk-image-editor" */ '../image-editor.vue'),
        Draggable: () => import(/* webpackChunkName: "chunk-vuedraggable", webpackPrefetch: true */ 'vuedraggable'),
        UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ '../ui/ui-alert.vue'),
        UploaderProgress: () => import(/* webpackChunkName: "chunk-uploader" */ './uploader-progress.vue'),
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        acceptedType: {
            type: String,
            default: 'image/jpeg, image/png',
        },
        // These are useful to switch to the legacy version of uploader.
        privacyPolicyEnabled: {
            type: Boolean,
            default: false,
        },
        isLegacy: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Array,
            default: () => {
                return [];
            }
        },
        action: {
            type: String,
            required: false
        },
        csrfToken: {
            type: String,
            required: true,
        },
        initFormData: {
            type: Object,
            default: () => {}
        },
        initFormErrors: {
            type: Object,
            default: () => {}
        },
        countryCode: {
            type: String,
            required: true
        },
        privacyPolicyUrl: {
            type: String,
            required: true
        },
        editImagesOnlyMessage: {
            type: Boolean,
            default: false
        },
        imageSrcVersionName: {
            type: String,
            required: true
        },
        imageSrcVersionValue: {
            type: String,
            required: true
        },
        imageMaxSizeWidth: {
            type: Number,
            required: true,
        },
        imageMaxSizeHeight: {
            type: Number,
            required: true,
        },
        postPromoteUrl: {
            type: String,
        },
        postPromoteUrlEncoded: {
            type: String,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        oneImageFreeAdAlert: {
            type: Boolean,
            default: false,
        },
        maxImagesPerPost: {
            type: Number,
            required: false,
        },
        //
        initUploadImageUrl: {
            type: String,
            required: true
        },
        initUploadImageMaxWidth: {
            type: Number,
            required: true
        },
        initUploadImageMaxHeight: {
            type: Number,
            required: true
        },
        initUploadImageMinWidth: {
            type: Number,
            required: true
        },
        initUploadImageMinHeight: {
            type: Number,
            required: true
        },
        initNumberOfAllowedImages: {
            type: Number,
            required: true
        },
        initPreviewImagesNumber: {
            type: Number,
            required: true
        },
        gdprFlagActive: {
            type: Boolean,
            required: true
        },
        flagImageUpload: {
            type: Boolean,
            required: true
        },
        privateCode: {
            type: String,
            required: false
        },
        temporaryCode: {
            type: String,
            required: false,
            default: '',
        },
        disableMouseEvents: {
            type: Boolean,
            default: false,
        },
        disableCrop: {
            type: Boolean,
            default: false,
        },
        disableRotate: {
            type: Boolean,
            default: false,
        },
        disablePreviewHeader: {
            type: Boolean,
            default: false,
        },
        maxImageSizeInMegaBytes: {
            type: Number,
            default: 10,
        },
        profileId: {
            type: String,
        },
        maxNumberOfImages: {
            type: Number,
            required: true
        }
    },
    data() {
        let postPictures = [];

        if (this.initFormData.images) {
            try {
                postPictures = JSON.parse(this.initFormData.images);
            } catch (e) {
                console.error("Failed to parse images:", e);
            }
        }

        const numberOfAllowedImages = this.initNumberOfAllowedImages;

        const uploaderMessage = ngettext(
            'You can upload up to <span>%(number_of_pictures)d</span> picture',
            'You can upload up to <span>%(number_of_pictures)d</span> pictures',
            numberOfAllowedImages);

        const modalImageNotSavedInstructions = ngettext(
            'You can upload up to %(number_of_pictures)d picture jpeg or png.',
            'You can upload up to %(number_of_pictures)d pictures jpeg or png.',
            this.maxNumberOfImages);

        return {
            i18n: {
                acceptToUpload: gettext('You must accept to upload your photos.'),
                yes: gettext('Yes'),
                no: gettext('No'),
                privacyText: gettext('I authorise the processing of my Photos by the Company for the purpose of publishing an ad on the Website %(privacy_url)s').replace('%(privacy_url)s', `<a target="_blank" :data-href="this.privacyPolicyUrl">(Privacy Policy).</a>`), // TODO: Check translation
                activePromotion: gettext('Active promotion'),
                canOnlyEditYourPhotos: gettext('you can only edit your own photos'),
                alertSavedImagesLoadingComplete: gettext('Drag and drop your picture <b>to order</b> your photo gallery'),
                imageTooSmall: gettext('The picture is too small to be clear. Try to insert a bigger picture.'),
                imageNotAllowed: gettext('Image removed!'),
                imageNotAllowedPreview: gettext('Image not allowed detected'),
                uploaderMessage,
                dragAndDropInstructionsNoMobile: gettext('Drag the picture here or'),
                dragAndDropInstructions: gettext('click to select them'),
                loadingCompleteMessage: gettext("If you don't choose any preview photos, first photo inserted in photo gallery will be selected as default preview photo."),
                onlyOnePictureForFreeAds: gettext('Only one picture visible for <b>free ads</b>'),
                modalInvalidImageTitle: gettext('We have verified the following mistakes'),
                modalImagesNotSaved: gettext('One or more images were not saved.'),
                modalImageNotSavedInstructions,
                modalImageNotSavedInstructions1: gettext('Size of each picture cannot be more than %(max_image_size)sMB.').replace('%(max_image_size)s', this.maxImageSizeInMegaBytes),
                modalImageNotSavedInstructions2: gettext('Not allowed content was detected in one or more images.'),
                modalImageNotSavedInstructions3: gettext('For verification, the photo must show only you. Make sure there are no other people in the picture.'),

                close: gettext('Close'),
            },
            postPictures,
            imagesArray: JSON.parse(JSON.stringify(this.value)), // get and copy v-model value

            uploadFlag: false, // upload is active
            isUploading: false,

            savedImagesLoadingComplete: false,
            savedImagesLoadingProgress: 0,
            // ASK: draggable functionality is disabled? Why?
            forceDisableSorting: true,
            draggableForceFallback: false, // see: https://github.com/SortableJS/Vue.Draggable/issues/743

            uploadBoxStyle: '',
            browserImages: {},
            cropperOpenDisableSorting: false,  // set to true when the cropper modal is open

            bytesToUpload: null,
            uploadedBytesPerFile: null,
            uploadProgress: 0,

            lightboxInvalidImageMessageContent: null,
            lightboxInvalidImageErrorCodes: new Set(),
            ERROR_CODE_INVALID_FORMAT: "1",
            ERROR_CODE_INVALID_CONTENT: "2",
            ERROR_CODE_MULTIPLE_FACES: "3",

            // settings
            maxImageSizeInBytes: this.maxImageSizeInMegaBytes * 1024 * 1024,
            postRequestMaxSize: 3 * 1024 * 1024,
            disableMouseEventsData: this.disableMouseEvents,


            // see: https://github.com/nodeca/pica#resizefrom-to-options---promise
            pica: null,
            picaResizeOptions: {
                unsharpAmount: 160,
                unsharpRadius: 0.6,
                unsharpThreshold: 1,
                alpha: true,
            },
            picaToBlobQuality: 1  //between 0 and 1
        }
    },
    computed: {
        uploadableImagesText() {
            return this.i18n.uploaderMessage.replace('%(number_of_pictures)d', this.initNumberOfAllowedImages - this.imagesArray.length);
        },
        modalImageNotSavedInstructionsText() {
            return this.i18n.modalImageNotSavedInstructions.replace('%(number_of_pictures)d', this.maxNumberOfImages);
        },
        enabledPhotoFlag() {
            return this.gdprFlagActive || this.flagImageUpload;
        },
        imageFlagDisable() {
            return (!this.uploadFlag && this.enabledPhotoFlag);
        },
        isDisabled() {
            return this.privacyPolicyEnabled && this.imageFlagDisable
        },
        panelClass() {
            return  {
                'media-uploader--disabled': this.isDisabled,
            }
        },
        disableSorting() {
            return this.forceDisableSorting || this.$root.isMobile || this.imageFlagDisable || this.imagesArray.length <= 1 || this.cropperOpenDisableSorting;
        },
        uploadBoxClass() {
           return this.imagesArray.length === 0 ? 'col-12' : 'col-md-3 col-xs-6 col-sm-6';
        },
        coverIndexes() {
            const arr = [];
            for(let i=0; i < this.imagesArray.length; i++) {
                if (this.imagesArray[i].isCover) {
                    arr.push(i);
                }
            }
            return arr;
        },
    },
    methods: {
        handleFileDrop(e) {
            e.preventDefault();
            const files = Array.from(e.dataTransfer.files);

            if(files.length > 0) {
                this.appendImageEditors(files);
            }
        },
        loadImageInput(e) {
            e.preventDefault();
            const files = e.srcElement.files;

            if(files.length > 0) {
                this.appendImageEditors(files);
            }
        },
        appendImageEditors(fileList) {
            this.$emit('image-upload-started');

            let displayErrorLightbox = false;
            let duplicatedFilenames = [];   //used to show duplicated images error message

            if(this.imagesArray.length + fileList.length > this.initNumberOfAllowedImages) {
                displayErrorLightbox = true;
            }

            const filesToUpload = [];

            // check files before continuing upload
            Array.from(fileList).forEach((pictureFile, index)  => {
                let error = false;
                if (filesToUpload.length + this.imagesArray.length +1 > this.initNumberOfAllowedImages){
                    // too many images
                    error = true;
                } else if (!pictureFile.type.match('image.*')) {
                    error = true;
                } else if (
                    //check file extension
                    !pictureFile.name.toLowerCase().endsWith('.jpg') &&
                    !pictureFile.name.toLowerCase().endsWith('.jpeg') &&
                    !pictureFile.name.toLowerCase().endsWith('.png')
                ) {
                    error = true;
                } else if (pictureFile.size > this.maxImageSizeInBytes) {
                    // check whether the size is greater than the size limit
                    error = true;
                    this.lightboxInvalidImageErrorCodes.add(this.ERROR_CODE_INVALID_FORMAT);
                }

                if(error) {
                    displayErrorLightbox = true;
                } else {
                    filesToUpload.push(pictureFile);
                }
            });

            this.isUploading = true;
            const resizePromises = [];

            // create an array of promises
            // each promise will resolve to an object like this:
            // {
            //    src: <the blob object used in cropper and preview, created with createObjectURL>,
            //    file: <the file or blob object, eventually resized to max width/height that will be uploaded>
            //    filename: <filename of the image>
            // }
            filesToUpload.forEach(pictureFile  => {
                // create object for the browser
                const pictureURL = URL.createObjectURL(pictureFile);
                // get file name
                const filename = pictureFile.name;

                // create new canvas, used as destination for resized image
                const offScreenCanvasDest = document.createElement('canvas');


                resizePromises.push(new Promise((resolve, reject) => {

                    pReadFileAsArrayBuffer(pictureFile.slice(0,4)).then(buffer => {
                        //check file types using initial bytes of the file
                        // i.e read first 4 bytes and transform them in hex

                        const arr = new Uint8Array(buffer);
                        let headerHex = "";
                        for(let i = 0; i < arr.length; i++) {
                           headerHex += arr[i].toString(16);
                        }

                        const isJpeg = headerHex.startsWith('ffd8ff'); // jpeg https://filesignatures.net/index.php?page=all&order=SIGNATURE&sort=DESC&alpha=J
                        const isPng = headerHex === '89504e47';  // png

                        if( !(isJpeg || isPng) ) {
                            this.lightboxInvalidImageErrorCodes.add(this.ERROR_CODE_INVALID_FORMAT);
                            return Promise.resolve({
                                resolveValue: {
                                    errorMessage: `Incorrect image format: ${headerHex}`,
                                },
                            });
                        }

                        // resize image if bigger than width/height limits
                        return loadImage(pictureURL);
                    }).then(resImg => {
                        const resolveValue = get(resImg, 'resolveValue', undefined);
                        if(!isUndefined(resolveValue)) {
                            return Promise.resolve({resolveValue});
                        }

                        const orginalWidth = resImg.width;
                        const orginalHeight = resImg.height;

                        if(orginalWidth < this.initUploadImageMinWidth || orginalHeight < this.initUploadImageMinHeight) {
                            this.lightboxInvalidImageErrorCodes.add(this.ERROR_CODE_INVALID_FORMAT);
                            return Promise.resolve({
                                resolveValue: {
                                    errorMessage: `Image size is smaller than minimum size required: ${this.initUploadImageMinWidth}x${this.initUploadImageMinHeight}px`,
                                },
                            });
                        }

                        // calculate aspect ratio
                        const imgRatio = Math.min(
                            this.initUploadImageMaxWidth/orginalWidth,
                            this.initUploadImageMaxHeight/orginalHeight
                        );

                        if(imgRatio >= 1) {
                            // don't upscale small images
                            // return original file
                            return Promise.resolve({
                                resolveValue: {
                                    src: pictureURL,
                                    file: pictureFile,
                                    filename,
                                },
                            });
                        }

                        offScreenCanvasDest.width  = orginalWidth * imgRatio;
                        offScreenCanvasDest.height = orginalHeight * imgRatio;

                        // Load Pica (if not already loaded)
                        if (!this.pica) {
                          return loadPica().then(picaModule => {
                            this.pica = new picaModule.default({features: ['js']});
                            return {
                              picaLoaded:true,
                              picaInstance: this.pica,
                              image: resImg
                            };
                          });
                        } else {
                          return Promise.resolve({
                            picaLoaded: false,
                            picaInstance: null,
                            image: resImg
                          });
                        }
                    }).then(result => {
                        const resolveValue = get(result, 'resolveValue', undefined);
                        if(!isUndefined(resolveValue)) {
                            return Promise.resolve({resolveValue});
                        }

                        if(result.picaLoaded){
                          this.pica = result.picaInstance;
                        }
                        return Promise.resolve(result.image);
                    }).then(result => {
                        const resolveValue = get(result, 'resolveValue', undefined);
                        if(!isUndefined(resolveValue)) {
                            return Promise.resolve({resolveValue});
                        }

                        // resize
                        return this.pica.resize(result, offScreenCanvasDest, this.picaResizeOptions);
                    }).then(result => {
                        const resolveValue = get(result, 'resolveValue', undefined);
                        if(!isUndefined(resolveValue)) {
                            return Promise.resolve({resolveValue});
                        }

                        return this.pica.toBlob(offScreenCanvasDest, pictureFile.type, this.picaToBlobQuality);
                    }).then(blob => {
                        const resolveValue = get(blob, 'resolveValue', undefined);
                        if(!isUndefined(resolveValue)) {
                            return Promise.resolve({resolveValue});
                        }

                        return Promise.resolve({
                            resolveValue: {
                                src: URL.createObjectURL(blob),
                                file: blob,
                                filename,
                            },
                        });
                    }).then(result => {
                        if(has(result, 'resolveValue')){
                            resolve(result.resolveValue);
                        }else{
                            reject(`missing resolveValue in ${result}`);
                        }
                    }).catch((error) => {
                        reject(error);
                    });
                }));
            });

            // await promises
            Promise.all(resizePromises)
            .then((imagesToUpload) => {
                if(imagesToUpload.length === 0) {
                    throw new Error('No images to upload');
                }

                // initialize progress counters
                this.bytesToUpload = 0;
                this.uploadedBytesPerFile = fill(Array(imagesToUpload.length), 0);

                const uploadPromises = [];
                for(let idx=0; idx<imagesToUpload.length; idx++) {
                    const imgToUpload = imagesToUpload[idx];
                    if(has(imgToUpload, 'errorMessage')){
                        displayErrorLightbox = true;
                        // skip image
                        continue;
                    }

                    this.bytesToUpload += imgToUpload.file.size;
                    uploadPromises.push(
                        new Promise((resolve, reject) => {
                            //create form data and add image file
                            const formData = new FormData();
                            formData.append('pictureFiles', imgToUpload.file);
                            if(this.privateCode) {
                                formData.append('privateCode', this.privateCode);
                            }
                            if(this.temporaryCode) {
                                formData.append('temporaryCode', this.temporaryCode);
                            }
                            if(this.profileId) {
                                formData.append('profileId', this.profileId);
                            }

                            // upload one image
                            this.$http.post(
                                this.initUploadImageUrl,
                                formData,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'X-CSRFToken': this.$cookies.get('csrftoken')
                                    },
                                    onUploadProgress: progressEvent => {
                                        this.uploadedBytesPerFile[idx] = progressEvent.loaded;
                                        const up = 100 * sum(this.uploadedBytesPerFile) / this.bytesToUpload;
                                        this.uploadProgress = Math.min(Math.round(up), 100);
                                    },
                                }
                            ).then((response) => {
                                // response contains a single image
                                return resolve({
                                    filename: imgToUpload.filename,
                                    imageSrc: imgToUpload.src,
                                    serverResponse: response.data.pictures[0]
                                });
                            }).catch((error) => {
                                console.error(`upload post error for file ${imgToUpload.filename}: ${error}`);
                                return resolve({
                                    error: error?.response?.data,
                                    filename: imgToUpload.filename,
                                });
                            });
                        })
                    );
                }

                // return upload promises
                return Promise.all(uploadPromises);
            }).then((responseImages) => {
                // create images array
                for(let i=0; i<responseImages.length; i++) {
                    const responseImage = responseImages[i];
                    // ignore images with errors
                    if(has(responseImage, 'error')) {
                        if(has(responseImage.error, 'error_code')) {
                            this.lightboxInvalidImageErrorCodes.add(responseImage.error.error_code);
                            displayErrorLightbox = true;
                        }
                        continue;
                    }

                    // prevent loading of duplicated images
                    const imgUuid = responseImage.serverResponse.uuid;
                    const imgHistogram = responseImage.serverResponse.histogram;
                    const imgFingerprint = responseImage.serverResponse.fingerprint;

                    if(this.imagesArray.find(function(im){ return im.histogram === imgHistogram; })){
                        duplicatedFilenames.push(responseImage.filename);
                        displayErrorLightbox = true;
                        continue;
                    }

                    // add image to v-model array
                    this.imagesArray.push({
                        uuid: imgUuid,
                        histogram: imgHistogram,
                        fingerprint: imgFingerprint,
                        // isNew: responseImage.serverResponse.isNew,
                        src: responseImage.serverResponse.url,
                        isCover: false,
                        crop: null,
                        rotate: 0,
                    });

                    // add image to cropper src images array
                    this.$set(this.browserImages, imgUuid, {
                        browserSrc: responseImage.imageSrc,
                        loadCompleted: false,
                    });

                    // add to cover images if possible
                    if (this.imagesArray.length > 0 && this.coverIndexes.length < this.initPreviewImagesNumber) {
                        this.imagesArray[this.imagesArray.length-1].isCover = true
                    }
                }

            }).catch((error) => {
                this.showErrorLightbox();
            }).finally(() => {
                this.$emit('image-upload-completed');
                this.bytesToUpload = null;
                this.uploadedBytesPerFile = null;
                this.uploadProgress = 0;
                this.isUploading = false;
                if (displayErrorLightbox) {
                    if(duplicatedFilenames.length === 1){
                        const fmts = gettext('The file %s has already been uploaded.');
                        this.lightboxInvalidImageMessageContent = interpolate(fmts, [duplicatedFilenames[0]]);
                    } else if(duplicatedFilenames.length > 1){
                        this.lightboxInvalidImageMessageContent = gettext('The selected files are existing. We recommend you to add more photos.');
                    }
                    this.showErrorLightbox();
                }
            });
        },
        setCover(index) {
            // remove image from covers
            if(this.imagesArray[index].isCover){
                if (this.initPreviewImagesNumber > 1) {
                    this.imagesArray[index].isCover = false;
                }
                return;
            }

            // add image to covers
            if(this.coverIndexes.length >= this.initPreviewImagesNumber){
                // remove last image from covers
                this.imagesArray[this.coverIndexes[this.initPreviewImagesNumber-1]].isCover = false;
            }
            // set image as cover
            this.imagesArray[index].isCover = true;
        },
        deleteImage(index) {
            const wasCover = this.imagesArray[index].isCover;
            const imgUuid = this.imagesArray[index].uuid;

            this.$delete(this.imagesArray, index);
            this.$delete(this.browserImages, imgUuid);

            if(wasCover) {
                if(this.coverIndexes.length === 0 && this.imagesArray.length > 0) {
                    // use another image as cover
                    if (index === 0) {
                       this.imagesArray[0].isCover = true;
                    } else {
                        this.imagesArray[index - 1].isCover = true;
                    }
                }
            }
        },
        // TODO: Replace with ligthboxes queue system
        showErrorLightbox() {
            $(this.$refs.lightboxInvalidImage).modal('show');
        },
        closeErrorLightbox(){
            $(this.$refs.lightboxInvalidImage).modal('hide');

            // reset error message to default
            this.lightboxInvalidImageMessageContent = null;
            this.lightboxInvalidImageErrorCodes = new Set();
        },
        updateImageEditData(index, editData) {
            this.imagesArray[index].rotate = editData.rotate;
            this.imagesArray[index].crop = editData.crop;
        },
        cropperModalShown(index) {
            this.cropperOpenDisableSorting = true;
            this.disableMouseEventsData = true;
        },
        cropperModalHidden(index) {
            this.cropperOpenDisableSorting = false;
            this.disableMouseEventsData = false;
        },
        onImageLoadCompleted(imgUuid, {updatePreviewFn}) {
            this.browserImages[imgUuid].loadCompleted = true;
            this.browserImages[imgUuid].updatePreviewFn = updatePreviewFn;
            if(this.savedImagesLoadingComplete) {
                // call update function
                this.$nextTick().then(()=>{
                    updatePreviewFn();
                });
            }
        },
        onClientSizeData(imgUuid, clientSizeData) {
            this.$set(this.browserImages[imgUuid], 'clientSize', clientSizeData);
        },
    },
    created() {
        loadBowser()
            .then(({ default: Bowser }) => {
                const browser = Bowser.getParser(window.navigator.userAgent);
                const forceFallback = !!browser.satisfies({
                    'MacOS': {
                        safari: ">1",
                    },
                });
                this.draggableForceFallback = forceFallback;
            })
            .catch((error) => {
                console.error(error);
                this.draggableForceFallback = true;
            });
    },
    mounted() {
        this.uploadFlag = false;
        this.savedImagesLoadingComplete = true;

        // initialize browser images object, for uploaded images
        for(let i=0; i<this.imagesArray.length; i++){
            this.$set(this.browserImages, this.imagesArray[i].uuid, {browserSrc: null, loadCompleted: false, savedImage: true});
            this.uploadFlag = true;
            this.savedImagesLoadingComplete = false;
        }

        // preventing page from redirecting
        $("html").on("dragover", (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        $("html").on("drop", (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        // // Drag enter
        // $(this.$refs.imageBox).on('dragenter', '.media-uploader__drop-zone', (e) => {
        //     e.stopPropagation();
        //     e.preventDefault();
        // });

        // // Drag over
        // $(this.$refs.imageBox).on('dragover', '.media-uploader__drop-zone', (e) => {
        //     e.stopPropagation();
        //     e.preventDefault();
        // });

        // // Drop
        // $(this.$refs.imageBox).on('drop', '.media-uploader__drop-zone', (e) => {
        //     e.stopPropagation();
        //     e.preventDefault();
        //     if(!this.enabledPhotoFlag || this.uploadFlag){
        //         const files = e.originalEvent.dataTransfer.files;
        //         if(files.length > 0) {
        //             this.appendImageEditors(files);
        //         }
        //     }
        // });

        // TODO: Find alternative way (not a popover) to show the message
        // Is lighter and we can clean lots of code
        if(this.privacyPolicyEnabled) {
            $(this.$refs.imageBox).on('click', '.media-uploader__drop-zone', (e) => {
                if(this.enabledPhotoFlag && !this.uploadFlag){
                    this.PopoverItem = $(this.$refs.uploadFlagLabel);
                    this.PopoverItem.popover("show");
                    $('.popover').addClass('popover-no-time-selected');
                    this.PopoverItem[0].scrollIntoView({block: "center"});

                    e.stopPropagation();
                    e.preventDefault();
                }
            });
            window.addEventListener('click', (e)=>{
                if (!$(this.$refs.uploadDropZone).is(e.target)){
                    this.PopoverItem = $(this.$refs.uploadFlagLabel);
                    this.PopoverItem.popover("hide");
                }
            });
        }
    },
    watch: {
        imagesArray: {
            deep: true,
            handler(val){
                this.$emit('input', val);
            }
        },
        browserImages: {
            deep: true,
            immediate: true,
            handler(val){
                const imgValues = values(val);

                // set "upload image box" height
                const maxHeight = maxBy(imgValues, (im) => get(im, 'clientSize.totalHeight', undefined));
                if(maxHeight) {
                    this.uploadBoxStyle = `height: ${maxHeight.clientSize.totalHeight}px;`;
                } else {
                    this.uploadBoxStyle = `height: auto;`;
                }

                // load progress
                const savedImages = imgValues.filter((img) => has(img, 'savedImage'));
                if(savedImages.length === 0 || this.savedImagesLoadingComplete) {
                    this.savedImagesLoadingProgress = 100;
                    return;
                }

                // only counts images that are loaded in mounted hook (have savedImage key)
                this.savedImagesLoadingProgress = Math.round(savedImages.filter((img) => img.loadCompleted).length / savedImages.length  * 100);
            },
        },
        savedImagesLoadingProgress: {
            handler(val){
                if(val === 100) {
                    // fire updatePreview on images that were loaded in mounted hook
                    const updateFunctions = map(values(this.browserImages), 'updatePreviewFn');
                    this.$nextTick().then(()=>{
                        updateFunctions.forEach(f => f());
                    });
                    this.savedImagesLoadingComplete = true;
                }
            }
        },
    }
}
</script>
